<script lang="ts" setup>
const props = defineProps<{ page: Page }>()

useSeoMeta({
  title: props.page?.name,
  twitterDescription: props.page?.meta_description ?? '',
  twitterTitle: props.page?.name,
  ogTitle: props.page?.name,
  ogDescription: props.page?.meta_description ?? '',
  description: props.page?.meta_description ?? '',
})

defineOgImageComponent('Page', { title: props.page.name, description: props.page.meta_description, image: getImagePath({ collectionId: PAGE_COLLECTION_ID, id: props.page.id, src: props.page.meta_image }) })

const schema = computed(() => buildPageSchema(props.page))

// Precompute the JSON string (SSR safe)
const schemaJson = computed(() => JSON.stringify(schema.value))

useHead({
  link: [
    {
      rel: 'canonical',
      href: getPublicRoute('pages', props.page, true),
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: schemaJson.value,
    },
  ],
})
</script>

<template>
  <div
    v-if="page?.expand?.sections?.length"
    class="flex w-full flex-col z-10 relative overflow-hidden"
  >
    <template
      v-for="(section, index) in page.expand.sections"
      :key="section.id"
    >
      <div
        class="relative"
      >
        <div
          v-if="index !== 0"
          v-motion
          :visible="{ opacity: 1, scale: 1 }"
          :initial="{ opacity: 0, scale: 0.2 }"
          :delay="500"
          class="absolute  text-lightblue z-[20] transform top-[5rem]"
          :class="[getColor(index), getPosition(index)]"
        >
          <Icon
            v-if="!isOdd(index)"
            name="gbf:arrow-swish-left"
            class="w-32 h-20 lg:w-64 lg:h-32 arrow -rotate-[25deg]"
          />
          <Icon
            v-else
            name="gbf:arrow-swish-right"
            class="w-32 h-20 lg:w-64 lg:h-32 arrow rotate-[27deg] flip"
          />
        </div>
      </div>
      <component
        :is="SECTION_MAP[section.type]"
        v-bind="section"
        v-if="section.type"
        :hydrate-on-visible="index > 1"
        :index="index"
      />
    </template>
  </div>
</template>
